import React, { useState, useEffect } from 'react';
import { useDifusiones } from "../context/DifusionesContext";
import { useAreas } from '../../Areas/State/AreasContext';
import { ModalGeneral } from '../../Componentes/ModalGeneral';
import ItemListaEmails from "../ItemListaEmails";
import { Typography, Divider, Chip, Box, Stack, CircularProgress } from '@mui/material';

export const VistaListasModal = ({ open, onClose, listaSeleccionada }) => {
    const { areasUser } = useDifusiones();
    const { getArea } = useAreas();
    const [nombreArea, setNombreArea] = useState(null);

    useEffect(() => {
        if (!open || !listaSeleccionada?.propietario) return;
        const areaLocal = areasUser.find(a => a.id === listaSeleccionada.propietario);
        if (areaLocal) {
            setNombreArea(areaLocal.name);
            return;
        }
        setNombreArea(null);
        getArea(listaSeleccionada.propietario).then(area => setNombreArea(area?.nombre ?? ''));
    }, [open]);

    return (
        <ModalGeneral
            open={open}
            onClose={onClose}
            titulo="Detalles de la Lista"
            Contenido={
                <Box mt={2}>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography variant="h5" color="primary">
                            {listaSeleccionada.nombre}
                        </Typography>
                        <Chip
                            label={nombreArea === null
                                ? <CircularProgress size={12} color="inherit" />
                                : nombreArea || "Área no encontrada"
                            }
                            color="primary"
                        />
                    </Box>

                    <Box sx={{ my: 5 }}>
                        {listaSeleccionada.compartidos?.length > 0 ? (
                            <>
                                <Divider sx={{ my: 2 }}>
                                    <Typography variant="caption" color="text.secondary">Compartida con Áreas</Typography>
                                </Divider>
                                <Box mb={3}>
                                    <Stack spacing={0.5} component="ul" pl={2}>
                                        {listaSeleccionada.compartidos.map((area, i) => (
                                            <li key={i}>
                                                <Typography variant="body1">{area.name}</Typography>
                                            </li>
                                        ))}
                                    </Stack>
                                </Box>
                            </>
                        ) : (
                            null
                        )}
                    </Box>

                    <Divider sx={{ my: 2 }}>
                        <Typography variant="caption" color="text.secondary">Destinatarios</Typography>
                    </Divider>

                    <ItemListaEmails emails={listaSeleccionada.integrantes} isModificar={false} />
                </Box>
            }
        />
    );
};
